import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { useNavigate, matchRoutes, useLocation } from 'react-router-dom';

import {
  styled,
} from '@mui/material';

import {
  AppBarTitle, Button, Chip, KeyIcon, Stack, Tooltip,
} from '@datanomik/commons-ui';

import { ArrowLeftLine } from '@datanomik/commons-ui/icons';

import { APP_ROUTES } from '@/assets/MenuItems';

import { styles } from './styles';

const BreadcrumbsRaw = ({ className }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const menuMatchRoutes = matchRoutes(APP_ROUTES, location);

  const handleGoBack = () => {
    navigate(-1);
  };

  if (!menuMatchRoutes) return null;

  const { length, 1: parentRoute, [length - 1]: routeItem } = menuMatchRoutes;

  let route = routeItem?.route;
  if (parentRoute && !parentRoute.route.element) {
    route = parentRoute.route;
  }

  if (routeItem?.route.hiddenPageTitle) return null;

  const showBack = !routeItem?.route?.hideBackButton;
  const isBeta = menuMatchRoutes.some((r) => r.route.isBeta);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="14px"
    >
      {showBack && (
        <Tooltip title={t('Back')}>
          <Button
            color="black"
            variant="text"
            onClick={handleGoBack}
            startIcon={<ArrowLeftLine />}
          />
        </Tooltip>
      )}
      <AppBarTitle
        className={className}
        startAdornment={(
          <KeyIcon size="large">
            {route?.icon}
          </KeyIcon>
        )}
        text={(
          <Stack direction="row" alignItems="center" spacing={1}>
            <span>{t(route?.label)}</span>
            {isBeta && (
              <Chip
                label="Beta"
                sx={{ backgroundColor: 'warning.lighter', color: 'warning.darker' }}
              />
            )}
          </Stack>
        )}
        subText={t(route?.description)}
      />
    </Stack>
  );
};

const Breadcrumbs = styled(BreadcrumbsRaw)(styles);

BreadcrumbsRaw.propTypes = {
  className: PropTypes.string,
};

Breadcrumbs.propTypes = BreadcrumbsRaw.propTypes;

export default Breadcrumbs;
